import React from 'react';
import {
  Column,
  DropdownButtonCell,
  DropdownButtonCellComponentProps,
  DropdownButtonSkeleton,
  getFixedWidthFaIcon,
} from '@odin-labs/components';
import { faTrash } from 'components/icons';
import { DataSharingGrant } from './types';

export type DataSharingGrantColumn = Column<DataSharingGrant>;

const TrashIcon = getFixedWidthFaIcon({ icon: faTrash });

enum DataSharingGrantColumnId {
  Client = 'client',
  AgreementReference = 'agreementReference',
  Capability = 'capability',
  Actions = 'actions',
}

export const getColumns = ({
  openRevokeModal,
}: {
  openRevokeModal: (grant: DataSharingGrant) => void;
}): DataSharingGrantColumn[] => [
  {
    id: DataSharingGrantColumnId.Client,
    Header: 'Client',
    accessor: (grant: DataSharingGrant): string =>
      grant?.granteeDeveloper?.name,
  },
  {
    id: DataSharingGrantColumnId.AgreementReference,
    Header: 'Agreement reference',
    accessor: (grant: DataSharingGrant): string => grant?.agreementReference,
  },
  {
    id: DataSharingGrantColumnId.Capability,
    Header: 'Access',
    accessor: (grant: DataSharingGrant): string => grant?.capability,
  },
  {
    id: DataSharingGrantColumnId.Actions,
    Header: '',
    Cell: DropdownButtonCell,
    CellLoading: (): React.ReactElement => (
      <DropdownButtonSkeleton cellAlignment="right" />
    ),
    componentProps: (
      grant: DataSharingGrant,
    ): DropdownButtonCellComponentProps => ({
      cellAlignment: 'right',
      menuItems: [
        [
          {
            icon: TrashIcon,
            text: 'Revoke access',
            theme: 'danger',
            onClick: (): void => openRevokeModal(grant),
          },
        ],
      ],
    }),
  },
];
